import { render, staticRenderFns } from "./NoteViewContainer.vue?vue&type=template&id=0171a99e&scoped=true"
import script from "./NoteViewContainer.vue?vue&type=script&lang=js"
export * from "./NoteViewContainer.vue?vue&type=script&lang=js"
import style0 from "./NoteViewContainer.vue?vue&type=style&index=0&id=0171a99e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0171a99e",
  null
  
)

export default component.exports